import { CommonModule } from '@angular/common';
import { Component, Input, } from '@angular/core';
import { HTTPMethod } from 'src/app/constants/enum';


@Component({
  selector: 'app-api-title',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './api-title.component.html'
})
export class ApiTitleComponent {

  @Input() apiMethod:string=``;
  @Input() url = ``;
  constructor(){}

  getColor(value:any){
    if(HTTPMethod.GET == value){
      return 'bg-success'
    }
    return 'bg-default';
  }
}
